import { useEffect } from "react";
import { FONTS, loadFonts } from "../../lib/fonts";

export function FontPicker({ value, onChange, sample }) {
  useEffect(() => { loadFonts(FONTS, "admin-font-catalog"); }, []);
  return (
    <div className="border rounded-lg max-h-60 overflow-y-auto divide-y bg-white" data-testid="site-name-font-picker">
      {["", ...FONTS].map((n) => {
        const on = (value || "") === n;
        return (
          <button key={n || "default"} type="button" onClick={() => onChange(n)} data-testid={`font-option-${(n || "default").replace(/ /g, "-").toLowerCase()}`}
            className={`w-full flex items-center justify-between gap-3 px-3 py-2 text-left transition-colors ${on ? "bg-stone-900 text-white" : "hover:bg-stone-50"}`}>
            <span className="text-xl leading-tight truncate" style={n ? { fontFamily: `'${n}', cursive` } : undefined}>{sample || "Örnek"} · ĞŞİÖÇÜ</span>
            <span className={`text-[11px] shrink-0 ${on ? "text-stone-300" : "text-stone-400"}`}>{n || "Tema varsayılanı"}</span>
          </button>
        );
      })}
    </div>
  );
}
